export const resources = {
    he: {
        translation: {
            'Airsounds': 'איירסאונד',
            'Chart for': 'טכיגרמה עבור',
            'Today': 'עבור להיום',
            'Help': 'עזרה',
            'Close': 'סגור',
            'Measured at': 'נמדד ב',
            'noon': 'צהרי היום',
            'midnight': 'חצות',
            'No measured data': 'אין נתוני בלון',

            // Place names.
            'megido': 'מגידו',
            'sde-teiman': 'שדה תימן',
            'zefat': 'צפת',
            'bet-shaan': 'בית שאן',

            // Week days
            'Sun': 'ראשון',
            'Mon': 'שני',
            'Tue': 'שלישי',
            'Wed': 'רביעי',
            'Thu': 'חמישי',
            'Fri': 'שישי',
            'Sat': 'שבת',
        }
    },
};